module.exports = __webpack_public_path__ + "img/theroom_bottle.14bd1a5d.jpg";